/* eslint-disable no-console */
import Store from './store'
//import { register } from 'register-service-worker'
import {
  register
} from './sw/registerServiceWorkerUpdated.js'

if ((process.env.NODE_ENV === 'production')) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    activated(registration) {
      console.log(
        '[SERVICE WORKER]: is activated'
      )
      Store.dispatch('serviceWorkerActivated', true)
      //window.reload()
    },
    ready(registration) {
      console.log('[SERVICE WORKER]: has claimed pages')
      Store.dispatch('serviceWorkerActivated', true)
    },
    registered(registration) {
      console.log('[SERVICE WORKER]: is registered')
    },
    cached() {
      console.log('[SERVICE WORKER]: has precached all static resources')
      Store.dispatch('contentCached', true)
    },
    updatefound(registration) {
      console.log('[SERVICE WORKER]: update found')
      //Store.dispatch('serviceWorkerUpdated', true)
    },
    updated(registration) {
      console.log('[SERVICE WORKER]: updated')
      Store.dispatch('serviceWorkerUpdated', true)
    },
    offline() {
      console.log('[SERVICE WORKER]: App is offline, and being served from cache')
      Store.dispatch('applicationOffline', true)
    },
    error(error) {
      console.error('[SERVICE WORKER]: Error', error)
      Store.dispatch('serviceWorkerActivated', false)
    },
  })
}